const october2 = [
  {
    id: 1,
    classRoom: '4-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-10-07',
    startTime: '17:55',
    endTime: '18:25'
  },
  {
    id: 2,
    classRoom: '2-3',
    entry: 'Pravo',
    date: '2019-10-08',
    startTime: '11:00',
    endTime: '11:30'
  },
  {
    id: 3,
    classRoom: '3-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-10-08',
    startTime: '17:20',
    endTime: '17:50'
  },
  {
    id: 4,
    classRoom: '4-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-08',
    startTime: '18:35',
    endTime: '19:05'
  },
  {
    id: 5,
    classRoom: '4-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-08',
    startTime: '19:10',
    endTime: '19:40'
  },
  {
    id: 6,
    classRoom: '2-3',
    entry: 'Pravo',
    date: '2019-10-09',
    startTime: '11:00',
    endTime: '11:30'
  },
  {
    id: 7,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-09',
    startTime: '12:20',
    endTime: '12:50'
  },
  {
    id: 8,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-09',
    startTime: '12:55',
    endTime: '13:25'
  },
  {
    id: 9,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-09',
    startTime: '13:30',
    endTime: '14:00'
  },
  {
    id: 10,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-09',
    startTime: '14:10',
    endTime: '14:40'
  },
  {
    id: 11,
    classRoom: '3-5',
    entry: 'Prakticna nastava',
    date: '2019-10-09',
    startTime: '14:45',
    endTime: '15:15'
  },
  {
    id: 12,
    classRoom: '3-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-09',
    startTime: '15:25',
    endTime: '15:55'
  },
  {
    id: 13,
    classRoom: '4-5',
    entry: 'Ustav i prava gradjana',
    date: '2019-10-09',
    startTime: '16:00',
    endTime: '16:30'
  },
  {
    id: 14,
    classRoom: '3-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-10-10',
    startTime: '17:20',
    endTime: '17:50'
  },
  {
    id: 15,
    classRoom: '4-3',
    entry: 'Ustavno i privredno pravo',
    date: '2019-10-10',
    startTime: '18:35',
    endTime: '19:05'
  },
  {
    id: 16,
    classRoom: '3-6',
    entry: 'Ustav i prava gradjana',
    date: '2019-10-11',
    startTime: '14:10',
    endTime: '14:40'
  },
  {
    id: 17,
    classRoom: '3-5',
    entry: 'Organizacija zastite od pozara',
    date: '2019-10-11',
    startTime: '16:00',
    endTime: '16:30'
  },
]

export default october2;